import React from "react";
import { useSelector } from "react-redux";
import cx from "classnames";
import { SelectChangeEvent } from "@mui/material";

import { IFundedTradersStatus } from "../../../../api/service/index.types";
import AccountsProcessingAndInvoiceStatusSelect from "../../../FundedTrader/components/AccountsProcessingAndInvoiceStatusSelect";
import { IDialogConfirmProps } from "../FundedTradersTable/TableBody";
import s from "./styles.module.css";

interface IProps {
  setDialogConfirmProps: (v: IDialogConfirmProps) => void;
  funded_trader_status: IFundedTradersStatus;
  accounts_id: number;
  evaluation_type: null | string;
  is_forced_to_live: boolean;
}

const FundedTraderStatus: React.FC<IProps> = ({
  setDialogConfirmProps,
  accounts_id,
  funded_trader_status,
  evaluation_type,
  is_forced_to_live,
}) => {
  const {
    data: { fundedTradersStatusesList },
  } = useSelector((state) => state.fundedTradersStatusesList);

  const handleChangeStatus = async (
    e: SelectChangeEvent<string>,
    _: number,
    accounts_id: number
  ) => {
    setDialogConfirmProps({
      isOpen: true,
      dialogTitle: "Change funded trader status",
      dialogContentText: "Are you sure you want to change funded trader status?",
      id: -1,
      accounts_id,
      name: "",
      value: "",
      status_id: e.target.value as unknown as number,
      isEditInitialProcStatusAndInvoiceStatus: false,
    });
  };

  let bgClass = "";

  const status = fundedTradersStatusesList.find((s) => s.id === funded_trader_status.id);
  if (status) {
    bgClass = s[status.status];
  }

  if (is_forced_to_live) {
    bgClass = s["forcedToLive"];
  }

  return (
    <td>
      <AccountsProcessingAndInvoiceStatusSelect
        useSmallSize
        bgStylesClass={cx(s.bgContainer, bgClass)}
        options={fundedTradersStatusesList.map(({ id, status_name }) => ({
          value: id,
          label: status_name,
        }))}
        name="funded_trader_status"
        value={funded_trader_status.id}
        handleChange={handleChangeStatus}
        accounts_id={accounts_id}
        id={-1}
      />
    </td>
  );
};

export default FundedTraderStatus;
